import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Calendar, Search, Car } from "lucide-react";
import { api, CATEGORIES } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const SearchBar = ({ dark = false }) => {
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const [category, setCategory] = useState("Tous");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  useEffect(() => {
    api.get("/cities").then((r) => setCities(r.data)).catch(() => {});
  }, []);

  const submit = () => {
    const params = new URLSearchParams();
    if (city) params.set("city", city);
    if (category && category !== "Tous") params.set("category", category);
    if (start) params.set("start", start);
    if (end) params.set("end", end);
    navigate(`/cars?${params.toString()}`);
  };

  return (
    <div className="rounded-2xl bg-white/95 backdrop-blur-xl shadow-2xl border border-slate-200/80 p-4 sm:p-5">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
        <div className="md:col-span-2">
          <label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
            <MapPin className="h-3.5 w-3.5" style={{ color: "#C1272D" }} /> Ville / Zone
          </label>
          <Select value={city} onValueChange={setCity}>
            <SelectTrigger data-testid="search-city-select" className="h-11">
              <SelectValue placeholder="Toutes les villes" />
            </SelectTrigger>
            <SelectContent>
              {cities.map((c) => (
                <SelectItem key={c} value={c}>{c}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
            <Calendar className="h-3.5 w-3.5" style={{ color: "#006233" }} /> Départ
          </label>
          <input
            type="date"
            data-testid="search-start-date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
            className="h-11 w-full rounded-md border border-input bg-background px-3 text-sm"
          />
        </div>
        <div>
          <label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
            <Calendar className="h-3.5 w-3.5" style={{ color: "#006233" }} /> Retour
          </label>
          <input
            type="date"
            data-testid="search-end-date"
            value={end}
            min={start || undefined}
            onChange={(e) => setEnd(e.target.value)}
            className="h-11 w-full rounded-md border border-input bg-background px-3 text-sm"
          />
        </div>
        <div>
          <label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
            <Car className="h-3.5 w-3.5 text-slate-400" /> Catégorie
          </label>
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger data-testid="search-category-filter" className="h-11">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {CATEGORIES.map((c) => (
                <SelectItem key={c} value={c}>{c}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <Button
        onClick={submit}
        data-testid="search-submit-btn"
        className="w-full mt-4 h-12 text-base font-semibold text-white"
        style={{ background: "#006233" }}
      >
        <Search className="h-5 w-5 mr-2" /> Rechercher un véhicule
      </Button>
    </div>
  );
};
